import {
  Component,
  OnInit,
  inject,
  input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ThemeService } from 'src/app/services/theme.service';
import { SelectItem } from '@openng/optimus-ui/api';
import { AuthApiService } from 'src/app/services/api/auth-api.service';
import { AppTheme } from 'src/app/services/theme.service';
import { CLAIMS } from 'src/app/constants/auth-constants';
import { Toolbar } from '@openng/optimus-ui/toolbar';
import { ButtonDirective } from '@openng/optimus-ui/button';
import { SelectButton } from '@openng/optimus-ui/selectbutton';
import { FormsModule } from '@angular/forms';
import { Select, SelectChangeEvent } from '@openng/optimus-ui/select';
import { TranslateService } from '@ngx-translate/core';
import { StorageService } from 'src/app/services/storage.service';
import { firstValueFrom, forkJoin } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Toolbar, ButtonDirective, SelectButton, FormsModule, Select],
})
export class ToolbarComponent implements OnInit {
  private _themeService = inject(ThemeService);
  private _authApi = inject(AuthApiService);
  private _translateService = inject(TranslateService);
  private _storageService = inject(StorageService);

  readonly title = input('');
  readonly show = input(true);
  readonly menuToggle = output<any>();

  canChangeTheme: boolean = false;
  themeOptions: SelectItem[] = [];
  theme: AppTheme = 'light';

  languageOptions: SelectItem[] = [];
  selectedLanguage = 'en';

  async ngOnInit() {
    this._authApi.userClaimsUpdated.asObservable().subscribe((_) => {
      this.canChangeTheme = this._authApi.doesUserHaveClaim(
        CLAIMS.CHANGE_CRLINC_THEME
      );
    });

    this._themeService.themeChanged
      .asObservable()
      .subscribe((selectedTheme) => {
        this.theme = selectedTheme;
        this.themeOptions.forEach((x) => (x.disabled = false));
        this.themeOptions.find((x) => x.value === this.theme)!.disabled = true;
      });

    const themeLabels = await firstValueFrom(
      forkJoin({
        light: this._translateService.get('COMMON.LABEL.BUTTONS.LIGHT'),
        dark: this._translateService.get('COMMON.LABEL.BUTTONS.DARK'),
      })
    );

    this.themeOptions = [
      {
        label: themeLabels.light,
        value: 'light',
        disabled: true,
      },
      {
        label: themeLabels.dark,
        value: 'dark',
        disabled: false,
      },
    ];
    this.theme = this.themeOptions[0].value;

    const languageLabels = await firstValueFrom(
      forkJoin({
        english: this._translateService.get('COMMON.LABEL.BUTTONS.ENGLISH'),
        spanish: this._translateService.get('COMMON.LABEL.BUTTONS.SPANISH'),
      })
    );

    this.languageOptions = [
      {
        label: languageLabels.english,
        value: 'en',
      },
      {
        label: languageLabels.spanish,
        value: 'es',
      },
    ];
    this.selectedLanguage = this.languageOptions[0].value;

    if (environment.title === 'CR LINC - Dev') {
      this.languageOptions.push({
        label: 'DEV',
        value: 'dev',
      });
    }
    const selectedLang = await this._storageService.getLang();
    if (selectedLang !== null) {
      this.selectedLanguage = selectedLang;
    }
  }

  changeTheme() {
    this.themeOptions.forEach((x) => (x.disabled = false));
    this.themeOptions.find((x) => x.value === this.theme)!.disabled = true;
    this._themeService.switchTheme(this.theme);
  }

  onLanguageSelected(event: SelectChangeEvent) {
    this._translateService.use(event.value);
    this._storageService.storeLang(event.value);
  }
}
